/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum OrderQuoteSideKindSell {
    SELL = 'sell',
}
